import { render, staticRenderFns } from "./HeroSingleContent.vue?vue&type=template&id=8a777ec4&"
import script from "./HeroSingleContent.vue?vue&type=script&lang=js&"
export * from "./HeroSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports